import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DocumentMarkdown,
} from '@wundo/ui';

export interface ReportDialogProps {
  title: string;
  report: string | null;
  onClose: () => void;
}

/** A report from the chat, opened large enough to read as a document. */
export function ReportDialog({ title, report, onClose }: ReportDialogProps) {
  return (
    <Dialog open={report !== null} onOpenChange={(next) => !next && onClose()}>
      <DialogContent size='full'>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <div className='min-h-0 flex-1 overflow-y-auto px-8 pb-7'>
          <DocumentMarkdown>{report ?? ''}</DocumentMarkdown>
        </div>
      </DialogContent>
    </Dialog>
  );
}
